class CartRemoveButton extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', (event) => {
			event.preventDefault();
			const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
			cartItems.updateQuantity(this.dataset.index, 0);
		});
	}
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();
		this.lineItemStatusElement =
			document.getElementById('shopping-cart-line-item-status') ||
			document.getElementById('CartDrawer-LineItemStatus');

		const debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, ON_CHANGE_DEBOUNCE_TIMER);

		this.addEventListener('change', debouncedOnChange.bind(this));
	}

	cartUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
			if (event.source === 'cart-items') {
				return;
			}
			this.onCartUpdate(event);
		});
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
	}

	onChange(event) {
		let input = event.target;
		if (!event.target.dataset.index) {
			input = event.target.parentElement.querySelector('input');
		}
		if (!input || !input.dataset.index) {
			console.error('No input found to update quantity');
			return;
		}
		this.updateQuantity(
			input.dataset.index,
			input.value,
			input.getAttribute('name'),
			input.dataset.quantityVariantId
		);
	}

	onCartUpdate(event) {
		
		if (this.tagName === 'CART-DRAWER-ITEMS') {
			//skip this update because we have it happening in cart-drawer instead
			const that = this;
			fetch(`${routes.cart_url}?section_id=cart-drawer`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html');
					const targetContent = document.querySelector('#CartDrawer-Content');
					const sourceContent = html.querySelector('#CartDrawer-Content');
					if (targetContent && sourceContent) {
						targetContent.replaceWith(sourceContent);
					}
					
					// Update the cart drawer's is-empty class based on cart state
					const cartDrawer = document.querySelector('cart-drawer');
					const cartDrawerItems = document.querySelector('cart-drawer-items');
					if (cartDrawer && cartDrawerItems) {
						if (cartDrawerItems.classList.contains('is-empty')) {
							cartDrawer.classList.add('is-empty');
						} else {
							cartDrawer.classList.remove('is-empty');
						}
					}
					
					// Re-setup elements after content replacement with a small delay
					// to ensure DOM is fully updated
					setTimeout(() => {
						if (cartDrawer) {
							cartDrawer.setupElements();
							
							// Manual fallback: ensure all close buttons have event listeners
							const allCloseButtons = document.querySelectorAll('[data-close="cart-drawer"]');
							allCloseButtons.forEach(button => {
								// Remove any existing listeners to avoid duplicates
								button.removeEventListener('click', cartDrawer.close.bind(cartDrawer));
								// Add the listener
								button.addEventListener('click', cartDrawer.close.bind(cartDrawer));
							});
						}
					}, 10);
					
					if (event && event.openDrawer) {
						const addonRecommendations = document.querySelector('addon-recommendations');
						const addonRecommendationsModal = document.getElementById('addon-recommendations-modal');

						if (event.fetchAddons && addonRecommendationsModal && addonRecommendations) {
							addonRecommendations.loadRecommendations(event.productUrl, event.productVariantId);
							addonRecommendationsModal.open();
						} else {
							if (cartDrawer) {
								cartDrawer.open();
							}
						}
					}
				})
				.catch((e) => {
					console.error(e);
				});

			fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html');
					
					// Replace the entire cart icon bubble content
					const targetBubble = document.querySelector('#cart-icon-bubble');
					const sourceBubble = html.querySelector('#cart-icon-bubble');
					if (targetBubble) {
						if (sourceBubble) {
							targetBubble.innerHTML = sourceBubble.innerHTML;
						} else if (responseText) {
							targetBubble.innerHTML = responseText;
						}
					}					
				})
				.catch((e) => {
					console.error('cb err', e);
				});

			this.closest('cart-drawer').setupElements();
		} else {
			fetch(`${routes.cart_url}?section_id=main-cart-items`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html');
					const sourceQty = html.querySelector('cart-items');
					this.innerHTML = sourceQty.innerHTML;
				})
				.catch((e) => {
					console.error(e);
				});
		}
	}

	getSectionsToRender() {
		return [
			{
				id: 'main-cart-items',
				section: document.getElementById('main-cart-items').dataset.id,
				selector: '.js-contents',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section',
			},
			{
				id: 'cart-live-region-text',
				section: 'cart-live-region-text',
				selector: '.shopify-section',
			},
			{
				id: 'main-cart-footer',
				section: document.getElementById('main-cart-footer').dataset.id,
				selector: '.js-contents',
			},
			{
				id: 'cart-json',
				section: 'cart-json',
				selector: '.shopify-section',
			},
		];
	}

	updateQuantity(line, quantity, name, variantId) {
		this.enableLoading(line);

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				const quantityElement =
					document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
				const items = document.querySelectorAll('.cart-item');

				if (parsedState.errors) {
					quantityElement.value = quantityElement.getAttribute('value');
					this.updateLiveRegions(line, parsedState.errors);
					return;
				}

				this.classList.toggle('is-empty', parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector('cart-drawer');
				const cartFooter = document.getElementById('main-cart-footer');

				if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
				if (cartDrawerWrapper) {
					cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
				}

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document.getElementById(section.id).querySelector(section.selector) ||
						document.getElementById(section.id);

					if (section.id === 'CartDrawer') {
						const newSectionDom = this.getSectionDOM(
							parsedState.sections[section.section],
							section.selector
						);
						if (newSectionDom) {

							const newSectionCountdown = newSectionDom.querySelector('cart-countdown');
							const oldSectionCountdown = elementToReplace.querySelector('cart-countdown');
							if (newSectionCountdown && oldSectionCountdown) {
								const newSectionCountdownParent = newSectionCountdown.parentElement;
								newSectionCountdown.remove();
								newSectionCountdownParent.appendChild(oldSectionCountdown);
							}

							const newSectionGoalMeter = newSectionDom.querySelector('cart-goal-meter');
							const oldSectionGoalMeter = elementToReplace.querySelector('cart-goal-meter');
							if (newSectionGoalMeter && oldSectionGoalMeter) {
								const newCartTotal = newSectionGoalMeter.dataset.cartTotal;
								const newSectionGoalMeterParent = newSectionGoalMeter.parentElement;
								newSectionGoalMeter.remove();
								newSectionGoalMeterParent.appendChild(oldSectionGoalMeter);
								setTimeout(() => {
									oldSectionGoalMeter.cartTotal = oldSectionGoalMeter.dataset.cartTotal =
										newCartTotal;
									oldSectionGoalMeter.updateDisplay();
								}, 50);
							}

							elementToReplace.replaceWith(newSectionDom);
							
						}
					} else {
						elementToReplace.innerHTML = this.getSectionInnerHTML(
							parsedState.sections[section.section],
							section.selector
						);
					}					
				});
				const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
				let message = '';
				if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
					if (typeof updatedValue === 'undefined') {
						message = window.cartStrings.error;
					} else {
						message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
					}
				}
				this.updateLiveRegions(line, message);

				window.saw_cart = JSON.parse(document.getElementById('cart-json').innerHTML);

				const lineItem =
					document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper
						? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
						: lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper.querySelector('.drawer__inner-empty'),
						cartDrawerWrapper.querySelector('a')
					);
				} else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
					trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
				}

				if (this.tagName === 'CART-DRAWER-ITEMS') {
					cartDrawerWrapper.setupElements();
				}

				publish(PUB_SUB_EVENTS.cartUpdate, {
					source: 'cart-items',
					cartData: parsedState,
					variantId: variantId,
				});
			})
			.catch((e) => {
				console.log('Error updating quantity', e);
				this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
				const errors =
					document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
				if (errors) {
					errors.textContent = window.cartStrings.error;
				}
			})
			.finally(() => {
				this.disableLoading(line);
				if (typeof SAWCartCheck == 'function') {
					SAWCartCheck();
				}
			});
	}

	updateLiveRegions(line, message) {
		const lineItemError =
			document.getElementById(`Line-item-error-${line}`) ||
			document.getElementById(`CartDrawer-LineItemError-${line}`);
		if (lineItemError) {
			const errorText = lineItemError.querySelector('.cart-item__error-text');
			if (errorText) {
				errorText.innerHTML = message;
			}
		}

		this.lineItemStatusElement.setAttribute('aria-hidden', true);

		const cartStatus =
			document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
		if (cartStatus) {
			cartStatus.setAttribute('aria-hidden', false);

			setTimeout(() => {
				cartStatus.setAttribute('aria-hidden', true);
			}, 1000);
		}
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
	}

	getSectionDOM(html, selector) {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
	}

	enableLoading(line) {
		const mainCartItems =
			document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
		if (mainCartItems) {
			mainCartItems.classList.add('cart__items--disabled');
		}

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading__spinner, #CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading__spinner, 
      #CartDrawer-Item-${line} .loading-overlay`
		);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute('aria-hidden', false);
	}

	disableLoading(line) {
		const mainCartItems =
			document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
		if (mainCartItems) {
			mainCartItems.classList.remove('cart__items--disabled');
		}

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading__spinner, #CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading__spinner, #CartDrawer-Item-${line} .loading-overlay`
		);

		cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
		cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
	}
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
	customElements.define(
		'cart-note',
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					'input',
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}
